module.exports = __webpack_public_path__ + "static/img/gold_bar_bg.3ded8a50.png";